"use strict";

var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// Preloader

const HOME = document.getElementById("home");
const hasPlayed = sessionStorage.getItem('preloaderPlayed');

HOME && HOME.classList.toggle("loading", !hasPlayed);

// End Preloader

const HEADER = document.getElementById("header");

(() => {
	document.documentElement.style.setProperty("--header-height", `${HEADER.clientHeight + HEADER.offsetTop}px`);

	window.addEventListener("load", () => {
		scrollW();
		window.addEventListener('scroll', scrollW);

		// Tertiary Nav Teconsent

		let teconsent = document.getElementById("teconsent");

		if (teconsent) {
			teconsent.classList.add("tertiary-navigation__item");
			document.getElementById("tertiary-navigation").insertBefore(teconsent, document.getElementById("tertiary-navigation").lastChild);
		}

		// Custom functions

		document.querySelectorAll(".js-offset").forEach(element => {
			element.style.setProperty("--offset", `${element.scrollHeight}px`);
		});

		document.querySelectorAll(".js-accordion-title").forEach(element => {
			element.parentElement.style.setProperty("--width", `${element.clientWidth}px`);
		});

		// Preloader

		if (HOME && !hasPlayed) {
			requestAnimationFrame(() => {
				window.scrollTo({
					top: 0
				});
			});

			HOME.classList.add("fill-in-1");

			setTimeout(() => {
				HOME.classList.add("fill-in-2");
			}, 2000);

			setTimeout(() => {
				HOME.classList.remove("loading");
				HOME.setAttribute("aria-busy", "false");

				sessionStorage.setItem('preloaderPlayed', 'true');
			}, 4000);
		}
	});

	// Remove empty <p> tags created by TinyMCE

	for (const p of document.getElementsByClassName("p")) {
		p.innerHTML.trim() === '' && p.remove();
	}

	// ScrollTo Animation

	window.location.hash && animateTo(window.location.hash.substring(1));

	document.querySelectorAll('[href*="#"]:not([data-lbx]').forEach(cta => {
		let target = cta.hash.substring(1);

		if (!document.getElementById(target))
			return;

		cta.addEventListener("click", (e) => {
			e.preventDefault();
			animateTo(target);
		});
	});

	// Toggle Buttons

	document.querySelectorAll(".js-toggle").forEach(btn => {
		let target = document.getElementById(btn.dataset.target);

		if (!target)
			return;

		btn.addEventListener("click", (e) => {
			e.preventDefault();
			target.classList.toggle("active");
		});
	});

	let prevActiveEl;

	const toggleActiveObserver = new MutationObserver(mutationList => {
		mutationList.forEach(mutation => {
			const target = mutation.target;
			let isCollapsing = !target.classList.contains("active");

			target.nextElementSibling.setAttribute("aria-expanded", target.classList.contains("active"));

			function updateScroll() {
				const delta = target.nextElementSibling.getBoundingClientRect().bottom - window.innerHeight;

				Math.abs(delta) > 1 && window.scrollBy(0, delta * 0.1);

				isCollapsing && requestAnimationFrame(updateScroll)
			}

			if (isCollapsing) {
				requestAnimationFrame(updateScroll);

				target.nextElementSibling.addEventListener("transitionend", () => {
					isCollapsing = false;
				}, { once: true });
			}
		});
	});

	document.querySelectorAll(".js-toggle-active").forEach(element => {
		element.nextElementSibling.hasAttribute("aria-expanded") && toggleActiveObserver.observe(element, { attributes: true, attributeFilter: ["class"] });

		element.addEventListener("click", () => {
			prevActiveEl && prevActiveEl !== element && prevActiveEl.classList.contains("active") && prevActiveEl.classList.remove("active");
			element.classList.toggle("active");
			prevActiveEl = element;
		});
	});
	

	// Set Up Animations

	addAnimations(".form-module", "top");
	addAnimations(".text-modules", "top");
	addAnimations(".global-sitemap", "top");

	// Main Navigation Set Up

	const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

	document.getElementById("primary-nav").querySelectorAll(".submenu").forEach(submenu => {
		submenu.style.setProperty("--offset", `${submenu.scrollHeight}px`);

		!hoverQuery.matches && submenu.parentElement.addEventListener("click", function (e) {
			e.target === this && this.classList.toggle("active");
		});
	});
})();

function scrollW() {
	const scrollTop = document.documentElement.scrollTop;

	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}

	lastScrollTop = Math.max(scrollTop, 0);  // Ensure lastScrollTop doesn't go below 0
}

function animateTo(target) {
	const toTarget = document.getElementById(target);

	if (!toTarget)
		return;

	const headerRects = (document.getElementById("header") || document.getElementsByTagName("header")[0]).getBoundingClientRect();
	const from = window.scrollY;
	const to = toTarget.getBoundingClientRect().top + from - (headerRects.height + headerRects.top);
	const duration = 1400;
	const start = performance.now();

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

	function step(timestamp) {
		const time = timestamp - start;
		const progress = Math.min(time / duration, 1);
		const yH = easeInOutQuart(progress) * (to - from) + from;

		window.scrollTo(0, yH);

		time < duration && requestAnimationFrame(step);
	}

	requestAnimationFrame(step);
}

function addAnimations(selector, behavior = null) {
	for (const item of document.querySelectorAll(selector)) {
		item.classList.add("animate-fade", behavior);
	}
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
	const menu = document.querySelector('#main-menu');
	const isMenuVisible = menu && menu.classList.contains('active');
	const elements = document.querySelectorAll('.privary-navigation__item a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}

document.addEventListener('DOMContentLoaded', function() {
    // Abrir el lightbox
    document.querySelectorAll('a[data-lightbox][href^="#"]').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            var targetId = this.getAttribute('href').replace('#', '');
            var target = document.getElementById(targetId);
            if (target) {
                target.classList.add('show');
				target.classList.remove('disintegrate');
                function closeHandler(ev) {
                    if (
                        ev.target.classList.contains('close-lightbox') ||
                        (!target.contains(ev.target) && ev.target !== link)
                    ) {
                        target.classList.add('disintegrate');
                        setTimeout(function() {
                            target.classList.remove('show', 'disintegrate');
                        }, 2000);
                        document.removeEventListener('mousedown', closeHandler);
                    }
                }
                document.addEventListener('mousedown', closeHandler);
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#main-menu');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});